import "./App.css";
import Home from './Screen/Home';
import About from './Screen/About';
import Whatastro from './Screen/Whatastro';
import Lifeprediction from './Screen/Lifeprediction';
import Palmleaf from './Screen/Palmleaf';
import Booking from './Screen/Booking';
import Gallery from './Screen/Gallery';
import Googlemeet from "./Screen/Googlemeet";
import Whatsapp from "./Screen/Whatsapp";
import Contact from './Screen/Contact';
import Skype from "./Screen/Skype";
import PrivacyPolicy from "./Screen/privacypolicy";
import TermsConditions from './Screen/TermsConditions';
import Onlineconsult from './Screen/onlineconsult';
import Chapters from "./Screen/Chapters";
import Remedies from "./Screen/Remedies";
import History from "./Screen/History";
import Prediction from "./Screen/Prediction";
import Chaptercard from "./Screen/Chaptercard";
import Remedycard from "./Screen/Remedycard";



import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <>  
    

      <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Whatastro" element={<Whatastro/>} />
          <Route path="/Lifeprediction" element={<Lifeprediction />} />
          <Route path="/Palmleaf" element={<Palmleaf />} />
          <Route path="/Booking" element={<Booking />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/onlineconsult" element={<Onlineconsult />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Googlemeet" element={<Googlemeet />} />
          <Route path="/Whatsapp" element={<Whatsapp />} />
          <Route path="/Chapters" element={<Chapters />} />
          <Route path="/History" element={<History />} />
          <Route path="/Remedies" element={<Remedies />} />
          <Route path="/Prediction" element={<Prediction />} />
          <Route path="/Chaptercard" element={<Chaptercard />} />
          <Route path="/Skype" element={<Skype />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
          <Route path="/Remedycard" element={<Remedycard />} />
        </Routes>
      </div>
    </Router>

    <section>
    
    <a href="https://wa.me/917402167580" class="fixed-whatsapp-button">
        <i class="fab fa-whatsapp whatsapp-icon"></i>
    </a>
    <a href="https://join.skype.com/invite/urtITmugbnwa" class="fixed-skype-button">
        <i class="fab fa-skype skype-icon"></i>
    </a>
    <a href="mailto:shivanadiastrologer@gmail.com" class="fixed-mail-button">
        <i class="fas fa-envelope mail-icon"></i>
    </a>
    
</section> 






</>


  );
}

export default App;
